module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: {
      'font-big': _vm.fontSize == 'big', 'font-medium': _vm.fontSize == 'medium', 'is-fixed': _vm.isFiltersOpened && _vm.isMobile
    },
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('cookies'), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "text": "Back to top",
      "visibleOffset": "200",
      "title": _vm.$lang.go_top
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e65fff7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 348
// module chunks = 1